import { Touchpoint } from '@/constants/enum';
import { apiCaller } from '@/redux/query';
import { isSkipApiSelector } from '@/redux/slice/auth.slice';
import sessionSlice, { touchpointSelector } from '@/redux/slice/session.slice';
import { useDispatch, useSelector } from 'react-redux';

const useTrackTouchpoint = () => {
  const dispatch = useDispatch();
  const touchpoint = useSelector(touchpointSelector);
  const isSkip = useSelector(isSkipApiSelector);
  const [track] = apiCaller.useTrackTouchpointMutation();

  const trackTouchpoint = (key: Touchpoint) => {
    if (!touchpoint[key] && !isSkip) {
      track({ touchpoint: key });
      dispatch(sessionSlice.actions.handleTouchpoint(key));
    }
  };

  return trackTouchpoint;
};

export default useTrackTouchpoint;
